// src/components/ui/TableSkeleton.tsx
import React from 'react';

export const TableSkeleton: React.FC<{ rows?: number; columns?: number }> = ({
  rows = 5,
  columns = 5,
}) => {
  return (
    <div className="w-full animate-pulse divide-y divide-slate-200">
      <div className="bg-slate-50 px-6 py-3.5 flex gap-4">
        {Array.from({ length: columns }).map((_, i) => (
          <div key={`th-${i}`} className="h-4 bg-slate-200 rounded flex-1" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={`tr-${r}`} className="px-6 py-4 flex gap-4 items-center">
          {Array.from({ length: columns }).map((_, c) => (
            <div
              key={`td-${r}-${c}`}
              className="h-4 bg-slate-100 rounded flex-1"
              style={{ width: `${Math.floor(60 + Math.random() * 30)}%` }}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
